// Eén plek voor "deze <div> is eigenlijk een knop".
//
// Een `<div onClick>` werkt alleen met de muis: hij staat niet in de
// tabvolgorde, heeft geen rol, en Enter of spatie doen niets. In de
// keuzevensters van de software ('Eigen formulier', 'Nieuwe vraag toevoegen',
// 'Quote toevoegen', ...) is zo'n rij de enige manier om verder te komen, dus
// wie geen muis gebruikt komt daar niet doorheen.
//
// Waarom geen echte <button>? De rij bevat een <p> met het label, en een <p>
// binnen een <button> is ongeldige HTML: ARIA slaat de kinderen van een knop
// plat tot één naam, en React waarschuwt er niet voor.
// AI-CONTEXT: See docs/pitfalls.md#ui-heading-inside-button-stops-being-a-heading
// AI-CONTEXT: See docs/pitfalls.md#ui-hover-only-affordance-dies-on-mobile

/**
 * Props die een klikbare rij bedienbaar maken met het toetsenbord.
 *
 * Geen handler (geen rechten, gratis abonnement) geeft een leeg object terug:
 * de rij is dan geen tab-stop en doet zich niet voor als knop. Een knop die
 * niets doet is misleidender dan geen knop.
 *
 * @param {((event?: any) => void) | null | undefined} onClick - Wat de rij doet
 * @returns {{role?: string, tabIndex?: number, onClick?: Function, onKeyDown?: Function}}
 */
const clickableRowProps = (onClick) => {
    if (typeof onClick !== 'function') return {}

    return {
        role: 'button',
        tabIndex: 0,
        onClick,
        onKeyDown: (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return
            // Spatie scrollt de pagina, Enter kan een omhullend formulier
            // versturen; allebei niet wat de gebruiker hier bedoelt.
            event.preventDefault()
            onClick(event)
        },
    }
}

export default clickableRowProps
